
export class NoteDenomination {
  noteValue: number;
  quantity: number;
  totalValue: number;

  constructor(noteValue, quantity) {
    this.noteValue = noteValue;
    this.quantity = quantity;
    this.totalValue = Math.round(((this.noteValue * this.quantity) + Number.EPSILON) * 100) / 100;
  }
}

export class CoinDenomination {
  coinValue: number;
  quantity: number;
  bagQuantity: number;
  bags: number;
  totalValue: number;

  constructor(coinValue, quantity, bagQuantity, bags) {
    this.coinValue = coinValue;
    this.quantity = quantity;
    this.bagQuantity = bagQuantity;
    this.bags = bags;
    this.totalValue = Math.round(
      (((this.coinValue * this.quantity) + (this.coinValue * this.bagQuantity * this.bags)) + Number.EPSILON) * 100
    ) / 100;
  }
}

export class CashCount {
  total = 0;
  noteDenominations: NoteDenomination[] = [];
  coinDenominations: CoinDenomination[] = [];

  constructor(noteDenominations: NoteDenomination[], coinDenominations: CoinDenomination[]) {
    if(!noteDenominations || !coinDenominations || !noteDenominations.length || !coinDenominations.length) {
      return;
    }
    this.noteDenominations = noteDenominations;
    this.coinDenominations = coinDenominations;
    const noteValue = this.noteDenominations.reduce(
      (p, c) => p + c.totalValue, 0);
    const coinValue = this.coinDenominations.reduce(
      (p, c) => p + c.totalValue, 0);
    this.total = Math.round(((noteValue + coinValue) + Number.EPSILON) * 100) / 100;
  }
}
